import { lazy } from 'react';
import i18next from 'i18next';
import permissions from '@shared/config/permissions';
import { ProgramsIcon } from '@shared/ui/icons';

const BhiDashboard = lazy(() => import('../../../../../pages/bhi-dashboard'));
// L2 (Account Detail) — reached from a portfolio row click on L1.
// Same permission gate as L1; hidden from the sidebar (nav item is
// only the L1 root).
const BhiAccount = lazy(() => import('../../../../../pages/bhi-dashboard-account'));

// BHI Dashboard — behavioral health integration enrollment tracking.
// Gated on the dedicated BHI_DASHBOARD_VIEW bit (61) since
// 2026-08-21; Phase 1 rode on ADMIN_PATIENT_IMPORT.
const BHI_ROUTES_ROOT = {
  path: '/:currentAccountUuid/bhi-dashboard',
  exact: true,
  additional: {
    component: BhiDashboard,
    title: i18next.t('titles:bhiDashboard'),
    protected: true,
    icon: ProgramsIcon,
    permission: permissions.BHI_DASHBOARD_VIEW,
    disabledId: 'bhiDashboard',
    breadcrumb: {
      isRoot: true,
      label: ({ state }) =>
        state.i18n?.programsDashboard?.l1?.pageTitle ||
        state.i18n?.titles?.bhiDashboard ||
        'BHI Dashboard',
    },
  },
};

const BHI_ROUTES_ACCOUNT = {
  path: '/:currentAccountUuid/bhi-dashboard/:targetAccountUuid',
  exact: true,
  additional: {
    component: BhiAccount,
    title: i18next.t('titles:bhiDashboard'),
    protected: true,
    permission: permissions.BHI_DASHBOARD_VIEW,
    disabledId: 'bhiDashboard',
    parentRoute: BHI_ROUTES_ROOT,
    breadcrumb: {
      label: () => 'Account Detail',
    },
  },
};

export const BHI_ROUTES = {
  root: BHI_ROUTES_ROOT,
  account: BHI_ROUTES_ACCOUNT,
};
